// ReleaseNote10.jsx
import { Box, Typography } from "@mui/material";

const ReleaseNote10 = () => {
  return (
    <Box sx={{ backgroundColor: "#fff" }}>
      <Typography variant="h2" sx={{ mb: 2 }}>
        Release 10.0
      </Typography>

      <Typography variant="body2" sx={{ mb: 3 }}>
        Introducing the latest JUNE update with new features and enhancements.
      </Typography>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" sx={{ mb: 1 }}>
          <strong>Key Updates and Enhancements</strong>
        </Typography>

        <ul style={{ margin: 0, paddingLeft: "5%" }}>

          <li style={{ marginBottom: "16px" }}>
            <Typography variant="body2">
              <strong>
                Global Patent Bibliographic Search{" "}
                <span style={{ color: "green", fontSize: "0.85em", verticalAlign: "super" }}>
                  New!
                </span>
              </strong>
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              Search patent or publication numbers across multiple jurisdictions
              and automatically retrieve available bibliographic data directly
              from the EPO.
            </Typography>
          </li>

          <li style={{ marginBottom: "16px" }}>
            <Typography variant="body2">
              <strong>AppGen Module – Enhancement</strong>
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              Customize document titles for CIP, 371, and Bypass Continuation
              filing packages, giving you greater flexibility during document
              preparation.
            </Typography>
          </li>

          <li style={{ marginBottom: "16px" }}>
            <Typography variant="body2">
              <strong>SB-08 Generator – Enhancement</strong>
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              Increased the supported reference limit to 4,000 references from
              the current limit of 1,000 references for both DOCX and PDF
              outputs.
            </Typography>
          </li>

          <li style={{ marginBottom: "16px" }}>
            <Typography variant="body2">
              <strong>Embedded Font Removal – Enhancement</strong>
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              Generate USPTO-compatible PDFs with reduced file size while
              maintaining document quality.
            </Typography>
          </li>

          <li style={{ marginBottom: "16px" }}>
            <Typography variant="body2">
              <strong>OA Shell – Enhancement</strong>
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              OA Shell now automatically retrieves and extracts claims from the
              latest response or amendment available in the USPTO, eliminating
              the need to upload a separate claims document.
            </Typography>
          </li>

        </ul>
      </Box>
    </Box>
  );
};

export default ReleaseNote10;
